import IRunner from "./types/core/IRunner";

export default class AppRunner implements IRunner {
    public run(): void {
        console.log("Running");
    }
}
